var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34442 0.245231C9.24457 0.167318 9.12156 0.125 8.99491 0.125C8.86826 0.125 8.74525 0.167318 8.6454 0.245231L0.5625 6.54838L1.26152 7.43246L2.25 6.66173V13.625C2.25061 13.9232 2.36933 14.2089 2.58018 14.4198C2.79102 14.6306 3.07682 14.7494 3.375 14.75H14.625C14.9232 14.7494 15.209 14.6307 15.4199 14.4199C15.6307 14.209 15.7494 13.9232 15.75 13.625V6.66684L16.7385 7.43747L17.4375 6.55333L9.34442 0.245231ZM10.125 13.625H7.875V9.12497H10.125V13.625ZM11.25 13.625V9.12497C11.2497 8.82671 11.131 8.54076 10.9201 8.32985C10.7092 8.11895 10.4233 8.00031 10.125 7.99997H7.875C7.57672 8.00027 7.29075 8.11889 7.07983 8.3298C6.86892 8.54072 6.7503 8.82669 6.75 9.12497V13.625H3.375V5.78456L9 1.40269L14.625 5.79047V13.625H11.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5e01eec7ad965786654b44f1248dd562.svg";
export { ForwardRef as ReactComponent };